export default __webpack_public_path__ + "static/media/June2018.2944ac48.png";